// SubjectiveTestComponent.js
import React, { useCallback, useEffect, useState } from "react";
import {
  Typography,
  Grid,
  Divider,
  Box,
  Button,
  Stack,
  Backdrop,
} from "@mui/material";
import Question from "./QuestionComponents";
import { axiosClient } from "../../../../utils/auth.util";
import { useNavigate } from "react-router-dom";
// import "./TutorExam.css";
import AccessAlarmIcon from "@mui/icons-material/AccessAlarm";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { setFrom } from "../../../../redux/slice/tutorExamSlice";
import { useDispatch } from "react-redux";
import AlertDialog from "./SubjectiveModal";
import InitialWarningDialog from "./InitialWarningDialog";

const SubjectiveDemo = (props) => {
  const history = useNavigate();
  const dispatch = useDispatch();
  const [isObjectiveOpen, setIsObjectiveOpen] = useState(false);
  const [currentQuestionSet, setCurrentQuestionSet] = useState(1);
  const [loaderVisible, setLoaderVisible] = useState(false);
  const [showNumbers, setShowNumbers] = useState(false);

  const [subjectiveQuestion, setSubjectiveQuestion] = useState([]);
  const [subjectiveLoading, setSubjectiveLoading] = useState(false);
  const [isUploadingQuestionFile, setIsUploadingQuestionFile] = useState(false);
  const [timeOutId, setTimeOutId] = useState("");
  // subjective questions
  const [answers, setAnswers] = useState(
    Array(subjectiveQuestion.length || []).fill("")
  );
  const [files, setFiles] = useState(
    Array(subjectiveQuestion.length || []).fill([])
  );
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [isFirstQuestionAnswered, setIsFirstQuestionAnswered] = useState(false);
  const [editMode, setEditMode] = useState(
    Array(subjectiveQuestion.length || []).fill(false)
  );

  const [hours, setHours] = useState(4);
  const [hourMinute, setHourMinute] = useState(59);
  const [hourSeconds, setHourSeconds] = useState(59);

  const [open, setOpen] = useState(false);

  const [marks, setMarks] = useState(0);

  const [examId, setExamId] = useState("");
  const [subject, setSubject] = useState("");
  // console.log(subject);
  const [resultStatus, setResultStatus] = useState("");
  const [showInitialWarningDialog, setShowInitialWarningDialog] =
    useState(true);

  const handleChange = (index, value) => {
    const newAnswers = [...answers];
    newAnswers[index] = value;
    setAnswers(newAnswers);

    if (index === 0) {
      setIsFirstQuestionAnswered(Boolean(value.trim()));
    }
  };

  const handleEditToggle = (index) => {
    const newEditMode = [...editMode];
    newEditMode[index] = !newEditMode[index];
    setEditMode(newEditMode);
  };

  const handleFileChange = (index, e) => {
    setIsUploadingQuestionFile(false);
    const newFiles = [...files];
    const selectedFiles = Array.from(e.target.files);

    // Ensure newFiles[index] is an array
    if (!Array.isArray(newFiles[index])) {
      newFiles[index] = [];
    }
    let totalFileSize = 0;
    newFiles.forEach((eachQFiles) =>
      eachQFiles.forEach((indFile) => (totalFileSize += indFile?.size || 0))
    );

    selectedFiles.forEach((eachFile) => (totalFileSize += eachFile?.size || 0));
    console.log({ totalFileSize });

    if (totalFileSize > 60000) {
      alert("The total size of all uploaded files must not exceed 60 KB.");
      return;
    }

    // Check file limit
    if (selectedFiles.length + newFiles[index].length > 3) {
      alert("You can only upload a maximum of 3 files.");
      return;
    }

    selectedFiles.forEach((file) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        const base64Data = reader.result;
        const newFileName = `question${String(index + 1).padStart(1)}_file${
          newFiles[index].length + 1
        }`;
        newFiles[index] = [
          ...newFiles[index],
          {
            name: newFileName,
            mimeType: file.type,
            base64Data,
            size: file.size,
          },
        ];
        setFiles([...newFiles]);
      };
    });
  };
  const handleFileInputClick = () => {
    setIsUploadingQuestionFile(true);
    clearTimeout(timeOutId);

    const timerId = setTimeout(() => {
      setIsUploadingQuestionFile(false);
    }, 300000);
    setTimeOutId(timerId);
  };

  const handleDelete = (questionIndex, fileIndex) => {
    const newFiles = [...files];
    newFiles[questionIndex] = newFiles[questionIndex].filter(
      (_, index) => index !== fileIndex
    );
    setFiles(newFiles);

    // const formData = new FormData();

    // console.log(formData.append("image", files), "filessdfsdfs");
  };

  //   console.log(props.examId, "exam id");
  //   console.log(props.tutorId, "tutor id");

  const handleSubmit = useCallback(async () => {
    if (loaderVisible) {
      console.log("already clicked once");
      return;
    }
    setLoaderVisible(true);
    console.log({ subInSubmit: subject });

    try {
      const response = await axiosClient.post(
        "/tutorweb/submit-subjective-paper",
        {
          files: files,
          subject: subject,
          tutorId:
            JSON.parse(localStorage.getItem("tutor")).saveTutor.tutor_id ||
            props.tutorId,
          examId: examId,
          answers: answers,
          questions: subjectiveQuestion,
        }
      );

      if (response.status === 200 || response.status === 201) {
        setCurrentQuestionSet(3);
        setLoaderVisible(false);
        setOpen(true);

        // const getSheet = await Axios.post(
        //   "https://musiclancerapigcp-dev.el.r.appspot.com/v1/api/tutorweb/get_sheet",
        //   // "https://musiclancerapigcp-dev.el.r.appspot.com/v1/api/tutorweb/get_sheet",
        //   {
        //     answers,
        //     subjectList: props.subjectList,
        //     tutorId: props.tutorId,
        //     examId: props.examId,
        //   }
        // );

        // if (getSheet.data.success === true) {
        //   // alert("Congrats!!!You passed the test")
        //   // setMinutes(0)
        //   // setSeconds(0)
        //   let tutor1 = JSON.parse(localStorage.getItem("tutor"));
        //   let tutor_ls = JSON.parse(localStorage.getItem("tutor")).saveTutor;
        //   let tutor_exam_temp = JSON.parse(localStorage.getItem("tutor"))
        //     ?.saveTutor?.tutor_exam
        //     ? JSON.parse(localStorage.getItem("tutor"))?.saveTutor?.tutor_exam
        //     : [];

        //   if (getSheet.data.status === "pass") {
        //     // setCurrentQuestionSet((prev) => prev + 1);

        //     setIsObjectiveOpen(true);
        //     setOpen(true);
        //     localStorage.setItem("hasPassedExam", true);
        //     let tagsAr = [...tutor_ls.tags, getSheet?.data?.subject];

        //     let tutor_exam_obj = {
        //       exam_id: getSheet?.data?.exam_id,
        //       subject: getSheet?.data?.subject,
        //       marks: getSheet?.data?.result,
        //       passing_marks: getSheet?.data?.passing_marks,
        //       status: getSheet?.data?.status,
        //     };

        //     let temp_tutorSaveObj = {
        //       ...tutor_ls,
        //       tutStatus: "exl",
        //       tags: tagsAr,
        //       tutor_exam: [...tutor_exam_temp, tutor_exam_obj],
        //     };
        //     // console.log({ tutor_ls });
        //     let temp_tutorObj = {
        //       ...tutor1,F
        //       saveTutor: temp_tutorSaveObj,
        //     };
        //     // let tutor_stringified = JSON.stringify(temp_tutorObj);
        //     // localStorage.setItem("tutor", tutor_stringified);
        //     props.setLocalSt(temp_tutorObj);
        //     const tutorRatingVal = await axios.get(
        //       `https://central-device-apis.el.r.appspot.com/api/tutorWeb/getTutorRating/${
        //         JSON.parse(localStorage.getItem("tutor"))?.saveTutor?.tutor_id
        //       }`
        //     );
        //     // props.setTemp_tutExam(temp_tutorObj)
        //     const ratingVal = tutorRatingVal?.data?.ratingVal;
        //     console.log({ ratingVal });
        //     let marksVal = +getSheet?.data?.result * 4;
        //     let initialRating = ratingVal
        //       ? marksVal > 70 && marksVal <= 75
        //         ? (+tutor_ls?.rating + 6) / 2
        //         : marksVal > 75 && marksVal <= 80
        //         ? (+ratingVal + 7) / 2
        //         : marksVal > 80 && marksVal <= 85
        //         ? (+ratingVal + 8) / 2
        //         : marksVal > 85 && marksVal <= 90
        //         ? (+ratingVal + 9) / 2
        //         : marksVal > 90
        //         ? (+ratingVal + 10) / 2
        //         : +ratingVal
        //       : marksVal > 70 && marksVal <= 75
        //       ? 6
        //       : marksVal > 75 && marksVal <= 80
        //       ? 7
        //       : marksVal > 80 && marksVal <= 85
        //       ? 8
        //       : marksVal > 85 && marksVal <= 90
        //       ? 9
        //       : marksVal > 90
        //       ? 10
        //       : null;
        //     // console.log({tutor_ls , marksVal , initialRating})
        //     const res = await Axios({
        //       method: "post",
        //       // url:`https://musiclancerapigcp-dev.el.r.appspot.com/v1/api/tutorweb/setDetailsAfterExamDone/${
        //       url: `https://musiclancerapigcp-dev.el.r.appspot.com/v1/api/tutorweb/setDetailsAfterExamDone/${
        //         JSON.parse(localStorage.getItem("tutor")).saveTutor.tutor_id
        //       }`,
        //       data: {
        //         email: tutor_ls?.email,
        //         name: tutor_ls?.name,
        //         dept: tutor_ls?.dept,
        //         highest_degree: tutor_ls?.highest_degree,
        //         university: tutor_ls?.academic_info[0]?.college,
        //         skills: tutor_ls?.skills,
        //         best_subjects: tutor_ls?.best_subjects,
        //         wa_id: tutor_ls?.wa_id,
        //         software_skills: tutor_ls?.software_skills,
        //         tutStatus: "exl",
        //         rating: initialRating ? initialRating?.toFixed(2) + "" : null,
        //         tags: tagsAr,
        //       },
        //     });
        //   } else {
        //     // setCurrentQuestionSet(2);
        //     // setCurrentQuestionSet((prev) => prev + 1);
        //     setIsObjectiveOpen(true);
        //     // dispatch(setResultStatus("fail"));
        //     setStatus("fail");
        //     dispatch(setFrom("subjective"));
        //     let tutor_exam_obj = {
        //       exam_id: getSheet?.data?.exam_id,
        //       subject: getSheet?.data?.subject,
        //       marks: getSheet?.data?.result,
        //       passing_marks: getSheet?.data?.passing_marks,
        //       status: getSheet?.data?.status,
        //     };

        //     let temp_tutorSaveObj = {
        //       ...tutor_ls,
        //       tutStatus: "ex",
        //       tutor_exam: [...tutor_exam_temp, tutor_exam_obj],
        //     };
        //     console.log({ tutor_ls });
        //     let temp_tutorObj = {
        //       ...tutor1,
        //       saveTutor: temp_tutorSaveObj,
        //     };
        //     // let tutor_stringified = JSON.stringify(temp_tutorObj);
        //     // localStorage.setItem("tutor", tutor_stringified);
        //     // props.setTemp_tutExam(temp_tutorObj)
        //     props.setLocalSt(temp_tutorObj);
        //   }
        //   //   history.replace("/tutor_exam/submitted");
        //   //  setShowTimer(false);
        //   setOpen(true);
        //   setLoaderVisible(false);
        //   props.setResult_func(getSheet.data.result);
        //   props.setResultStatus_func(getSheet.data.status);
        //   props.setSubject_func(getSheet.data.subject);
        //   // setExamDone(true)
        //   console.log({ marks: getSheet.data.result });
        //   setMarks(getSheet.data.result);
        // }
      }
      // else {
      //   setLoaderVisible(false);
      //   alert("something went wrong!!");
      // }
    } catch (error) {
      console.error("Error during submission:", error);
      //   history.replace("/tutor_exam/submitted");
      // setOpen(true);
      alert("Some error occured. Please try after sometime");
      setLoaderVisible(false);
    } finally {
      setLoaderVisible(false);
    }
  }, [answers, files, props, subjectiveQuestion, dispatch, loaderVisible]);

  useEffect(() => {
    function handleVisibilityChange() {
      if (
        document.visibilityState !== "visible" ||
        document.visibilityState === "hidden"
      ) {
        console.log("hit");
        if (!open && !isUploadingQuestionFile) {
          handleSubmit();
        }
      }
    }

    document.addEventListener("visibilitychange", handleVisibilityChange);
    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, [handleSubmit, open, isUploadingQuestionFile]);

  const handlePrevious = () => {
    if (currentQuestionIndex > 0) {
      setCurrentQuestionIndex(currentQuestionIndex - 1);
    }
  };

  useEffect(() => {
    const timerId = setInterval(() => {
      setHourSeconds((prevSecond) => {
        if (prevSecond > 0) {
          return prevSecond - 1;
        } else {
          setHourMinute((prevMinute) => {
            if (prevMinute > 0) {
              setHourSeconds(59);
              return prevMinute - 1;
            } else {
              setHours((prevHour) => {
                if (prevHour > 0) {
                  setHourMinute(59);
                  setHourSeconds(59);
                  return prevHour - 1;
                } else {
                  clearInterval(timerId);
                  handleSubmit();
                  return prevHour;
                }
              });
              return prevMinute;
            }
          });
          return prevSecond;
        }
      });
    }, 1000);

    return () => clearInterval(timerId);
  }, [currentQuestionSet, handleSubmit]);

  const find_examId = useCallback(async () => {
    const response = await axiosClient.post(
      "/tutorweb/find_examId",
      {
        tutorId: JSON.parse(localStorage.getItem("tutor")).saveTutor.tutor_id,
      }
    );

    if (response.status === 201 || response.status === 200) {
      console.log(response.data.tutStatus, "<<<< tut status");
      let status = response.data.tutStatus;
      let obj;
      console.log("checking value6677");
      if (response.data.lastExamId) {
        console.log("checking value0099");
        obj = response.data.tutor_exam.find(
          (exam) => exam.exam_id === response.data.lastExamId
        );
        // dispatch(setExamObj(obj))
        if (status === "subs") {
          console.log("checking value11223344", obj);
          // examId = response.data.lastExamId;
          // subject = obj.subject
          // marks = (+obj.mcqMarks) * 4;
          // resultStatus = obj.mcqStatus
          setExamId(response.data.lastExamId);
          console.log("values in .subject", obj.subject);
          setSubject(obj.subject);
          setResultStatus(obj.subStatus);
          getSubjectiveQuestionDetails(obj.subject);
        } else if (status === "mcqs") {
          history("/register-dashboard/tutor_exam",{replace:true});
        } else if (status === "mcqe") {
          history("/register-dashboard/tutor_exam/submitted",{replace:true});
        } else if (status === "sube") {
          history("/register-dashboard/tutor_exam/subjective_result",{replace:true});
        }
      }
    }
  }, []);

  const getSubjectiveQuestionDetails = useCallback(async (subjectValue) => {
    const formattedSubjectList = subject.split(" ").join("_").toLowerCase();
    setSubjectiveLoading(true);
    try {
      console.log({ subject });
    const response = await axiosClient.get(
      `/tutorweb/questions/${subjectValue}`,
      {
        params: {
          tutorId: JSON.parse(localStorage.getItem("tutor")).saveTutor
            .tutor_id,
        },
      }
    );

      if (response.status === 200 || response.status === 201) {
        setSubjectiveQuestion(response.data.questions);

        setSubjectiveLoading(false);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setSubjectiveLoading(false);
    }
  }, []);

  useEffect(() => {
    find_examId();
  }, [find_examId]);

  if (subjectiveLoading) {
    return (
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
      />
    );
  }
  const closeWarning = () => {
    setShowInitialWarningDialog(false);
  };

  return (
    <div
      style={{ marginTop: "7.5rem" }}
      className="max-w-screen-md mx-auto py-2 "
    >
      {showInitialWarningDialog && (
        <InitialWarningDialog
          showInitialWarningDialog={showInitialWarningDialog}
          setShowInitialWarningDialog={setShowInitialWarningDialog}
          submitHandler={closeWarning}
        />
      )}
      <div id="countdown">
        {hours === 0 && hourMinute === 0 && hourSeconds === 0 ? (
          <div className="timer-cont">
            <div className="timer">
              <AccessAlarmIcon sx={{ fontSize: "30px" }} />
            </div>
            <div className="minutes">
              <div className="c-number">00:</div>
            </div>
            <div className="minutes">
              <div className="c-number">00:</div>
            </div>

            <div className="seconds">
              <div className="c-number">00 </div>
            </div>
          </div>
        ) : (
          <div className="timer-cont">
            <div className="timer">
              <AccessAlarmIcon sx={{ fontSize: "30px" }} />
            </div>
            <div className="minutes">
              <div className="c-number">
                {hours < 10 ? `0${hours}` : hours}:
              </div>
            </div>
            <div className="minutes">
              <div className="c-number">
                {hourMinute < 10 ? `0${hourMinute}` : hourMinute}:
              </div>
            </div>
            <div className="seconds">
              <div className="c-number">
                {hourSeconds < 10 ? `0${hourSeconds}` : hourSeconds}
              </div>
            </div>
          </div>
        )}
      </div>

      <div className="flex items-center justify-between ">
        <div
          style={{ textAlign: "left", dataAlign: "right" }}
          class="form-buttons-wrapper form-buttons-center   jsTest-button-wrapperField"
        >
          <Button
            onClick={() => setShowNumbers((prev) => !prev)}
            variant="outlined"
          >
            {showNumbers ? "Hide" : "Show"}
            {showNumbers ? <ExpandLessIcon /> : <ExpandMoreIcon />}
          </Button>
        </div>
        <div
          style={{ textAlign: "right", dataAlign: "right" }}
          class="form-buttons-wrapper form-buttons-center   jsTest-button-wrapperField"
        >
          <Stack flexDirection="row" gap={2}>
            <Button
              disabled={!isFirstQuestionAnswered}
              type="button"
              variant="contained"
              onClick={() => handleSubmit()}
            >
              Submit
            </Button>
          </Stack>
        </div>
      </div>
      <Grid
        container
        spacing={2}
        // className="border-[3px] border-indigo-500 p-4 mt-8"
        sx={{
          marginTop: "2.1rem",
          border: "3px solid #00a4bd",
          borderRadius: "7px",
        }}
      >
        <Grid item xs={12}>
          <Typography
            variant="h5"
            sx={{
              fontFamily: "Poppins",
              fontSize: "18px",
              fontWeight: "medium",
            }}
          >
            Subjective Question
          </Typography>
          <Divider
            sx={{
              backgroundColor: "#fcfcfc",
              height: "1.73px",
              borderRadius: "8px",
              marginTop: "1.2px",
            }}
          />
        </Grid>
        <Grid item xs={12}>
          {subjectiveQuestion && (
            <Question
              questions={subjectiveQuestion || []}
              answers={answers}
              currentQuestionIndex={currentQuestionIndex}
              editMode={editMode}
              files={files}
              handleChange={handleChange}
              handleDelete={handleDelete}
              handleEditToggle={handleEditToggle}
              handleFileChange={handleFileChange}
              handlePrevious={handlePrevious}
              handleSubmit={handleSubmit}
              isFirstQuestionAnswered={isFirstQuestionAnswered}
              setEditMode={setEditMode}
              setIsFirstQuestionAnswered={setIsFirstQuestionAnswered}
              handleFileInputClick={handleFileInputClick}
            />
          )}
        </Grid>
      </Grid>

      {open && (
        <AlertDialog
          open={open}
          onClick={() =>
            history("/register-dashboard/tutor_exam/subjective_result", {
              state: { marks: marks, status: "pending" },
            },{replace:true})
          }
        />
      )}
    </div>
  );
};

export default SubjectiveDemo;
